import { FC } from "react";
import moment, { Moment } from "moment";
import { Box, TextField, Tooltip } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import ViewEditTextField from "../view-edit-text-field";

interface ViewEditDateProps {
  props: {
    format?: string;
    id: string;
    isEdit: boolean;
    label: string;
    tooltip?: string;
    value?: string;
    handleInputChange?: (newValue: string, field: string) => void;
  };
}

const ViewEditDate: FC<ViewEditDateProps> = ({ props }) => {
  const dateFormat = "MM/DD/YYYY";

  const getMoment = (isoDateString: string | undefined): moment.Moment | null => {
    return isoDateString ? moment(isoDateString, true) : null;
  }

  const getDisplayFormat = (isoDateString: string | undefined): string => {
    let moment = getMoment(isoDateString);
    return moment ? moment.format(props.format || dateFormat) : "";
  };

  const handleOnChange = (newValue: any) => {
    if (props.handleInputChange) {
      const date = newValue ? (newValue as unknown as Moment).toISOString() : "";
      props.handleInputChange(date, props.id);
    }
  };

  return (
    <>
      {props.isEdit ? (
        <Box m={1} className="view-edit-box">
          <Tooltip title={props.tooltip ?? ""}>
            {/* Use a react fragment because Tooltip must be given a child that supports refs, and LocalizationProvider does not. */}
            <>
              <LocalizationProvider dateAdapter={AdapterMoment}>
                <DatePicker
                  label={props.label}
                  inputFormat={dateFormat}
                  mask="__/__/____"
                  value={getMoment(props.value)}
                  onChange={handleOnChange}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      margin="dense"
                      fullWidth
                      InputLabelProps={{
                        shrink: props.isEdit || (props.value ? true : false),
                      }}
                    />
                  )}
                />
              </LocalizationProvider>
            </>
          </Tooltip>
        </Box>
      ) : (
        <ViewEditTextField
          props={{
            id: props.id,
            label: props.label,
            initialValue: getDisplayFormat(props.value),
            isEdit: props.isEdit,
            characterLimit: 100,
            handleInputChange: handleOnChange,
          }}
        />
      )}
    </>
  );
};

export default ViewEditDate;
